import React, { useMemo, useState } from "react";
import TurnstileWidget from "../components/Turnstile";
import { apiPost } from "../lib/api";

type LandlordLeadCreated = {
  leadId: string;
  receivedAt?: string;
  echo?: unknown;
};

export default function LeadsLandlord() {
  const siteKey = (import.meta as any).env?.VITE_TURNSTILE_SITEKEY ?? "";

  const [form, setForm] = useState({
    city: "Barcelona",
    contactDetail: "",
    notes: "",
    privacyAccepted: true,
    turnstileToken: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<any>(null);

  const canSubmit = useMemo(() => {
    return form.city.trim() && form.privacyAccepted && form.turnstileToken.trim() && !submitting;
  }, [form, submitting]);

  async function submit() {
    setSubmitting(true);
    setResult(null);

    const payload = {
      city: form.city,
      contact_detail: form.contactDetail || null,
      notes: form.notes || null,
      consents: {
        privacyPolicyAccepted: form.privacyAccepted,
      },
      turnstileToken: form.turnstileToken,
    };

    const resp = await apiPost<LandlordLeadCreated>("/v1/landlord-leads", payload);

    setSubmitting(false);
    setResult(resp);
  }

  return (
    <div className="card">
      <h2>业主线索（/v1/landlord-leads）</h2>
      <p className="muted">
        最小必填字段：city / consents / turnstileToken（contact_detail 可选，但建议填写便于跟进）。
      </p>

      <div className="row">
        <label>
          城市*
          <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
        </label>
        <label>
          联系方式（电话/微信/邮箱）
          <input
            value={form.contactDetail}
            onChange={(e) => setForm({ ...form, contactDetail: e.target.value })}
          />
        </label>
      </div>

      <label>
        备注
        <textarea rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
      </label>

      <label style={{ display: "block", marginTop: 12 }}>
        <input
          type="checkbox"
          checked={form.privacyAccepted}
          onChange={(e) => setForm({ ...form, privacyAccepted: e.target.checked })}
        />{" "}
        我已阅读并同意隐私政策（privacyPolicyAccepted=true）*
      </label>

      <div className="card">
        <h3>Turnstile</h3>
        <TurnstileWidget
          siteKey={siteKey}
          onToken={(token) => setForm((p) => ({ ...p, turnstileToken: token }))}
          action="landlord_lead_submit"
        />

        {!siteKey ? (
          <div style={{ marginTop: 12 }}>
            <div className="muted">
              当前未配置 SiteKey：为了试跑流程，你可以手动填一个 token（mock 模式会接受任何非空字符串）。
            </div>
            <input
              placeholder="turnstileToken (dev/mock)"
              value={form.turnstileToken}
              onChange={(e) => setForm({ ...form, turnstileToken: e.target.value })}
            />
          </div>
        ) : null}
      </div>

      <button disabled={!canSubmit} onClick={submit}>
        {submitting ? "Submitting…" : "提交线索"}
      </button>

      {result ? (
        <div className="card">
          <h3>Response</h3>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      ) : null}
    </div>
  );
}
